import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiGoalResponseModel } from '@/types'

export const getKpiGoals = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<KpiGoalResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi-goal/filtered`, {
      params: {
        start: startDate,
        end: endDate,
        branches: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
